import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [data, setData] = useState(null);
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex items-center justify-between">
        <div>
          <p className="uppercase text-[10px] tracking-wider font-semibold text-muted-foreground">Pusat Notifikasi</p>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Notifikasi</h1>
        </div>
        <Button variant="outline" size="sm" onClick={readAll} data-testid="read-all-btn"><CheckCheck className="h-4 w-4 mr-1.5" /> Tandai semua dibaca</Button>
      </div>
      {!data ? <Skeleton className="h-40" /> : data.items.length === 0 ? (
        <Card className="p-16 text-center"><Bell className="h-10 w-10 mx-auto text-muted-foreground" /><p className="mt-3 text-muted-foreground">Tidak ada notifikasi.</p></Card>
      ) : (
        <div className="space-y-2">
          {data.items.map((n, i) => (
            <motion.div key={n.id} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.02 }}>
              <Card className={`p-4 flex items-start gap-3 ${!n.read ? "border-l-4 border-l-primary" : ""}`} onClick={() => !n.read && readOne(n.id)} data-testid="notif-item">
                <div className="h-9 w-9 rounded-lg bg-accent flex items-center justify-center shrink-0"><Bell className="h-4 w-4 text-primary" /></div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-sm">{n.title}</p>
                  <p className="text-sm text-muted-foreground">{n.message}</p>
                  <p className="text-[11px] text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</p>
                </div>
                {!n.read && <span className="h-2 w-2 rounded-full bg-primary shrink-0 mt-1" />}
              </Card>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
